import {proposal} from "../../globalState";
import {doc, getFirestore, setDoc} from "firebase/firestore";
import getFirebase from "../../firebase";

export function saveProposal(
    setLink,
    buildingName,
    columns,
    rideItems,
    logoImage,
    roomSimulationImage,
    roomSimulationImageDesc,
    rideSimulationImage,
    rideSimulationImageDesc,
    colorUnit,
    typeOfProperty,
    typeOfTemplate,
    numOfUnit,
    setupFee,
    setupFeeBeforeDiscount,
    serviceFee,
    serviceFeeBeforeDiscount,
    ride,
    rent,
    shop,
    hideIntroduction,
    separatePrinter,
    separateShop,
    location,
    ownerRevenue
) {
    return async () => {
        setLink("");

        const db = getFirestore(getFirebase());
        await setDoc(doc(db, "my_tulu", buildingName.trim()), {
            ...proposal,
            columns: JSON.stringify(columns),
            rideItems: ride ? JSON.stringify(rideItems) : JSON.stringify([]),
            logoImage,
            roomSimulationImage,
            roomSimulationImageDesc,
            rideSimulationImage,
            rideSimulationImageDesc,
            colorUnit,
            typeOfProperty,
            typeOfTemplate,
            numOfUnit,
            setupFee,
            setupFeeBeforeDiscount,
            serviceFee,
            buildingName,
            ride,
            rent,
            shop,
            hideIntroduction,
            separatePrinter,
            separateShop,
            location,
            ownerRevenue: ownerRevenue || 70,
        });

    };
}
